// @flow

import React, { type Node } from 'react';
import { Center, InlineLoadingIndicator } from '../../atoms';

export function LoadingContent(): Node {
  return (
    <Center style={{ minHeight: '320px' }}>
      <InlineLoadingIndicator />
    </Center>
  );
}
